import { render } from "./SVGHooksRight.vue?vue&type=template&id=1bd81a1c"
const script = {}

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__